export default function loadDataToLocalStorage(data) {
  Object.keys(data).forEach((key) => {
    localStorage.setItem(key, data[key])
  })
}
